import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=074e190a&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=074e190a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e190a",
  null
  
)

export default component.exports